module.exports = __webpack_public_path__ + "img/bigDoorLock.6118c0a7.png";